import { getKey } from './common';
import CONSTANT, { CACHE, RESPONSE_STATUS } from './constants';

export function getApi(cache) {
  return cache.getData(CACHE.API);
}

function _isSuccess(response) {
  return RESPONSE_STATUS.S === getKey(response, 'body.resultInfo.resultStatus');
}

function _getResponseBody(response) {
  return response && response.body;
}

function _getResultInfo(response) {
  return getKey(response, 'body.resultInfo', {});
}

export function ifSuccessOrThrowError(response, successCallback) {
  if (_isSuccess(response)) {
    const responseBody = _getResponseBody(response);
    return successCallback(responseBody);
  }
  const { resultMsg = CONSTANT.GENERIC_ERROR } = _getResultInfo(response);
  /* session expired handling is being done here so that apart from session expired handling,
  other errors continue as it is not to disturb the current flow */
  if (getKey(response, 'body.resultInfo.resultCode', '') === '1006') {
    const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    this.props.cache.getData(CACHE.STORE).setState({ sessionExpired: true });
    const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
    if (notifyMerchant && notifyMerchant.constructor === Function) {
      notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, response);
    }
    return resultMsg;
  }

  throw new Error(resultMsg);
}



// WEBPACK FOOTER //
// ./utils/api-response-utils.js